import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ProductComponent } from './product/product.component';
import { MatStepperModule } from '@angular/material/stepper';
import { UsersComponent } from './users/users.component';
import { MatSelectModule } from '@angular/material/select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserEditPopupComponent } from './userEditPopup/userEditPopup.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MatIconModule } from '@angular/material/icon';
import { EscalationMatrixComponent } from './escalation-matrix/escalation-matrix.component';
import { EnquiriesDashboardComponent } from './enquiries-dashboard/enquiries-dashboard.component';
import { ChartModule } from 'primeng/chart';
import { TreeSelectModule } from 'primeng/treeselect';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TestRideDashboardComponent } from './test-ride-dashboard/test-ride-dashboard.component';
import { FollowupDashboardComponent } from './followup-dashboard/followup-dashboard.component';
import { ProductivityDashboardComponent } from './productivity-dashboard/productivity-dashboard.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CountUpDirective } from '../shared/count-up.directive';
// import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LostDashboardComponent } from './lost-dashboard/lost-dashboard.component';
import { MatDateFormats, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ReportsComponent } from './reports/reports.component';
import { BiChartComponent } from '../bi-chart/bi-chart.component';
import { DigitalDeskDashboardComponent } from './digital-desk-dashboard/digital-desk-dashboard.component';
import { ImportUserComponent } from './import-user/import-user.component';
import { SupportComponent } from './support/support.component';

import { CardComponent } from './shared/card/card.component';
import { HeaderBarComponent } from './shared/header-bar/header-bar.component';
import { SharedModule } from '../shared/shared.module';
import { GeographyChartCarouselComponent } from './shared/geography-chart-carousel/geography-chart-carousel.component';
import { FilterBarComponent } from './shared/filter-bar/filter-bar.component';
import { FollowupChartComponent } from './shared/followup-chart/followup-chart.component';
import { DirFilterBarComponent } from './shared/dir-filter-bar/dir-filter-bar.component';

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
	parse: {
		dateInput: 'DD-MM-YYYY',
	},
	display: {
		dateInput: 'DD-MM-YYYY',
		monthYearLabel: 'MMMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

@NgModule({
	declarations: [
		ProductComponent,
		ResetPasswordComponent,
		UsersComponent,
		UserEditPopupComponent,
		UserProfileComponent,
		ChangePasswordComponent,
		DocumentUploadComponent,
		EscalationMatrixComponent,
		PageNotFoundComponent,
		EnquiriesDashboardComponent,
		TestRideDashboardComponent,
		FollowupDashboardComponent,
		ProductivityDashboardComponent,
		CountUpDirective,
		LostDashboardComponent,
		ReportsComponent,
		BiChartComponent,
		DigitalDeskDashboardComponent,
		ImportUserComponent,
		SupportComponent, 
		],
	imports: [
		FormsModule,
		ReactiveFormsModule,
		CoreRoutingModule,
		CommonModule,
		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		MatButtonModule,
		MatDialogModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatInputModule,
		MatNativeDateModule,
		MatTabsModule,
		MatStepperModule,
		MatSelectModule,
		MatIconModule,
		ChartModule,
		TreeSelectModule,
		NgApexchartsModule,
		MatSlideToggleModule,
		TooltipModule,
		// NgSelectComponent,
		NgSelectModule,
		NgMultiSelectDropDownModule.forRoot(),
		BsDatepickerModule.forRoot(),
		NgxSkeletonLoaderModule.forRoot(),
		CardComponent,
		HeaderBarComponent,
		SharedModule,
		GeographyChartCarouselComponent,
		ChartModule,
		FilterBarComponent,
		FollowupChartComponent,
		DirFilterBarComponent
	],
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Optional: for day-first format
		{ provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
	],
})
export class CoreModule { }
